module.exports = __webpack_public_path__ + "static/media/steph.fa61e47e.JPG";